import { useEffect, useMemo, useState } from 'react';
import { RouteComponentProps, useHistory } from 'react-router-dom';
import Spinner from '../../components/common/Spinner';
import {
  getCategoryWithQuestion,
  getQuestion,
  searchQuestion
} from './helpDesk.actions';
import {
  BreadCrumbs,
  HelpDeskContainer,
  SearchContainer,
  SearchInput,
  TopicCategory,
  TopicCategoryTitle
} from './HelpDeskStyled';
import { useTranslation } from 'react-i18next';
import { colors } from '../../styles/GlobalStyles';
import { Icon, IconSearch } from '../../styles/Icons';
import { SearchDropdown } from './SearchDropdown';
import debouce from 'lodash.debounce';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { AnimatedDashboard } from '../../components';
import { clearQuestions } from '../../slices/help-desk-slice';

type TParams = { id?: string; categoryId?: string };

export const Question = (props: RouteComponentProps<TParams>) => {
  const { t } = useTranslation('helpdesk');
  const history = useHistory();
  const [close] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const dispatch = useAppDispatch();

  const onChange = (e: any) => {
    if (e.target.value.length > 0) {
      dispatch(searchQuestion(e.target.value));
    } else {
      dispatch(clearQuestions());
    }
  };

  const debouncedResults = useMemo(() => {
    return debouce(onChange, 500);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    return () => {
      debouncedResults.cancel();
    };
  });

  const { question, category, questions, loading } = useAppSelector(
    (state) => state.helpDesk
  );

  useEffect(() => {
    if (props.match.params.id && props.match.params.categoryId) {
      dispatch(getQuestion(props.match?.params?.id));
      dispatch(getCategoryWithQuestion(props.match?.params?.categoryId));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  if (loading) return <Spinner fullScreen={true} />;

  return (
    <AnimatedDashboard>
      <div style={{ width: '100%' }}>
        <SearchContainer close={close}>
          <Icon mr='15' color={colors.neutral700}>
            <IconSearch />
          </Icon>
          <SearchInput
            type='text'
            onChange={debouncedResults}
            onFocus={() => setIsOpen(true)}
            placeholder={t('search_articles_placeholder')}
          />
          <SearchDropdown
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            questions={questions}
            category={category}
          />
        </SearchContainer>

        <HelpDeskContainer close={close}>
          <TopicCategory>
            <BreadCrumbs>
              <div
                style={{ cursor: 'pointer' }}
                onClick={() => history.goBack()}>
                {category?.name}
              </div>{' '}
              {'>'}
              <div style={{ marginLeft: 15 }}>{question?.question}</div>
            </BreadCrumbs>

            <TopicCategoryTitle>
              <h1>{question?.question}</h1>
            </TopicCategoryTitle>

            <>
              <div
                dangerouslySetInnerHTML={{
                  __html: question?.answer || ''
                }}
                style={{ maxWidth: 800 }}></div>
            </>
          </TopicCategory>
        </HelpDeskContainer>
      </div>
    </AnimatedDashboard>
  );
};
